import type { LaunchTileBehavior } from 'owa-graph-schema';

const getLaunchTilesDefaultBehavior = (): LaunchTileBehavior => {
    return {
        __typename: 'LaunchTileBehavior',
        transparent: false,
        pinningEnabled: false,
        shouldShowLabel: false,
        platformAppCommands: {
            aboutCommandEnabled: true,
            uninstallCommandEnabled: false,
        },

        // The localized version of these strings is provided by the TileContextMenu type policy
        tileContextMenu: {
            __typename: 'TileContextMenu',
            moreAppsLinkDisplayText: 'More apps',
            openInNewTabItemLabel: 'Open in new tab',
            aboutAppItemLabel: 'About',
            pinAppItemLabel: 'Pin',
            unpinAppItemLabel: 'Unpin',
            uninstallAppItemLabel: 'Uninstall',
        },
    };
};

export default getLaunchTilesDefaultBehavior;
